import { cva } from "class-variance-authority";
import React from "react";

import { cn } from "@/lib/chillnn/cn";

import Cross from "../icon/cross";

import type { VariantProps } from "class-variance-authority";

const roundedFullButtonVariants = cva("rounded-full grid place-content-center", {
	variants: {
		variant: {
			default: "bg-zinc-950 text-white hover:bg-zinc-800 shadow",
		},
		size: {
			default: "h-5 w-5",
		},
	},
	defaultVariants: {
		variant: "default",
		size: "default",
	},
});

export interface RoundedFullButtonProps
	extends React.ButtonHTMLAttributes<HTMLButtonElement>,
		VariantProps<typeof roundedFullButtonVariants> {}

export const RoundedFullButton = React.forwardRef<HTMLButtonElement, RoundedFullButtonProps>(
	({ className, variant, size, ...props }, ref) => {
		return (
			<button
				ref={ref}
				role="button"
				className={cn(roundedFullButtonVariants({ variant, size, className }))}
				{...props}
			>
				<Cross className="h-4 w-4 text-current" />
			</button>
		);
	},
);
